import React from 'react';

import { TeamKnowledgeCard } from '../../../../knowledge-cards/team-knowledge-card/team-knowledge-card';
import { useAIAnswerContext } from '../../../ai-answer-context';
import { NLPSearchJSONResultFormat } from '../../../nlp-search-json-result-format';
import { getTypedJSONResultDataAssistanceService } from '../../../utils/getTypedJSONResultData';
import { AIAnswerWhoResult } from './who-result/who-result-component';
import { AIAnswerWorkResult } from './work-result/work-result-component';

export const JsonResultComponent = (): React.JSX.Element | null => {
	const { commonAttributes } = useAIAnswerContext();

	const { answerString } = commonAttributes;
	const { parsedType } = getTypedJSONResultDataAssistanceService(answerString);
	switch (parsedType) {
		case NLPSearchJSONResultFormat.WHO:
			return <AIAnswerWhoResult />;
		case NLPSearchJSONResultFormat.WORK:
			return <AIAnswerWorkResult />;
		case NLPSearchJSONResultFormat.TEAM:
			return <TeamKnowledgeCard />;
		default:
			return null;
	}
};
